import { createFileRoute } from '@tanstack/react-router';
import { FileDown, Settings2 } from 'lucide-react';
import { Card } from '@/components/Card/Card';
import type {
  IRelatorioMapaProducaoExpedicaoFiltros,
  IRelatorioMapaProducaoExpedicaoMesOption,
} from '@/types/relatorioMapaProducaoExpedicao';
import './mapa-producao-expedicao.css';

export const Route = createFileRoute('/_authenticated/relatorio/mapa-producao-expedicao/form')({
  component: RelatorioMapaProducaoExpedicaoFormPage,
});

const MESES: IRelatorioMapaProducaoExpedicaoMesOption[] = [
  { value: 1, label: 'Janeiro' },
  { value: 2, label: 'Fevereiro' },
  { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Maio' },
  { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' },
];

const anoAtual = new Date().getFullYear();
const anos = Array.from({ length: 10 }, (_, index) => anoAtual - 5 + index);

export interface IRelatorioMapaProducaoExpedicaoFormProps {
  filtros: IRelatorioMapaProducaoExpedicaoFiltros;
  isGenerating?: boolean;
  errorMessage?: string;
  onFiltrosChange: (filtros: IRelatorioMapaProducaoExpedicaoFiltros) => void;
  onGenerate: () => void;
}

export function RelatorioMapaProducaoExpedicaoForm({
  filtros,
  isGenerating = false,
  errorMessage,
  onFiltrosChange,
  onGenerate,
}: IRelatorioMapaProducaoExpedicaoFormProps) {
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    onFiltrosChange({
      ...filtros,
      [name]: name === 'mes' || name === 'ano' ? parseInt(value, 10) : value,
    } as IRelatorioMapaProducaoExpedicaoFiltros);
  };

  return (
    <Card className="filter">
      <Card.Header>
        <div className="relatorio-mapa-filter-header">
          <Settings2
            size={18}
            aria-hidden="true"
          />
          <h3>Parâmetros do Relatório</h3>
        </div>
      </Card.Header>

      <Card.Content className="filter-card__content">
        <div className="relatorio-mapa-filters-grid">
          <div className="input-content">
            <span className="relatorio-mapa-field-label">Tipo de Mapa</span>
            <div className="relatorio-mapa-radio-group">
              <label className="relatorio-mapa-radio-label">
                <input
                  type="radio"
                  name="mapa"
                  value="producao"
                  checked={filtros.mapa === 'producao'}
                  onChange={handleInputChange}
                />
                Mapa Produção
              </label>
              <label className="relatorio-mapa-radio-label">
                <input
                  type="radio"
                  name="mapa"
                  value="expedicao"
                  checked={filtros.mapa === 'expedicao'}
                  onChange={handleInputChange}
                />
                Mapa Expedição
              </label>
            </div>
          </div>

          <div className="input-content">
            <label htmlFor="mes">Mês</label>
            <select
              id="mes"
              name="mes"
              value={filtros.mes}
              onChange={handleInputChange}
            >
              {MESES.map((mes) => (
                <option
                  key={mes.value}
                  value={mes.value}
                >
                  {mes.label}
                </option>
              ))}
            </select>
          </div>

          <div className="input-content">
            <label htmlFor="ano">Ano</label>
            <select
              id="ano"
              name="ano"
              value={filtros.ano}
              onChange={handleInputChange}
            >
              {anos.map((ano) => (
                <option
                  key={ano}
                  value={ano}
                >
                  {ano}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className="filter-button"
            onClick={onGenerate}
            disabled={isGenerating}
          >
            <FileDown
              size={16}
              aria-hidden="true"
            />
            {isGenerating ? 'Gerando...' : 'Gerar Relatório'}
          </button>
        </div>

        {errorMessage && (
          <div className="relatorio-mapa-message relatorio-mapa-message--error">
            {errorMessage}
          </div>
        )}
      </Card.Content>
    </Card>
  );
}

function RelatorioMapaProducaoExpedicaoFormPage() {
  return (
    <div className="relatorio-mapa-producao-expedicao-container">
      <div className="relatorio-mapa-producao-expedicao-content">
        <p className="relatorio-mapa-message relatorio-mapa-message--info">
          Utilize a listagem principal para gerar e exportar o relatório.
        </p>
      </div>
    </div>
  );
}
